import { inject, Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { BFF_SESSION_KEEP_ALIVE_INTERVAL_MS } from '../../constants/bff-session.constants';
import { AuthServiceBase } from '../auth/auth.service.base';
import { ScitBffHandshakeService } from './scit-bff-handshake.service';

/** Re-handshakes with the BFF while SCIT stays open so viewer tabs keep a valid session cookie. */
@Injectable({ providedIn: 'root' })
export class ScitBffSessionKeepAliveService {
  private auth = inject(AuthServiceBase);
  private handshake = inject(ScitBffHandshakeService);

  private intervalId: ReturnType<typeof setInterval> | null = null;
  private visibilityHandler: (() => void) | null = null;

  start(): void {
    if (!environment.mayaViewer?.enabled) {
      return;
    }

    this.stop();
    this.refreshIfAuthenticated();

    this.intervalId = setInterval(() => {
      this.refreshIfAuthenticated();
    }, BFF_SESSION_KEEP_ALIVE_INTERVAL_MS);

    this.visibilityHandler = () => {
      if (document.visibilityState === 'visible') {
        this.refreshIfAuthenticated();
      }
    };
    document.addEventListener('visibilitychange', this.visibilityHandler);
  }

  stop(): void {
    if (this.intervalId !== null) {
      clearInterval(this.intervalId);
      this.intervalId = null;
    }

    if (this.visibilityHandler) {
      document.removeEventListener('visibilitychange', this.visibilityHandler);
      this.visibilityHandler = null;
    }
  }

  private refreshIfAuthenticated(): void {
    if (!this.auth.isAuthenticated()) {
      return;
    }
    this.handshake.ensureSession().subscribe();
  }
}
